import React from 'react'
import Header from '../components/Header/Header'
import LeaveStatus from '../components/leave/LeaveStatus'

function LeaveStatusMain() {
  return (
    <div>
        <Header/>
        <LeaveStatus/>
    </div>
  )
}

export default LeaveStatusMain